module.exports = "<md-sidenav class=\"md-sidenav-left sidebar\" md-component-id=left md-is-locked-open=\"$mdMedia('gt-md') && c.$scope.$root.sidenavOpen\"> <div class=no-overflow-x role=navigation ss-style-color=\"{'background-color': '#f2f2f2'}\"> <ss-sidenav menu=c.menu></ss-sidenav> </div> </md-sidenav>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/sidebar/sidebar.html
 ** module id = 484
 ** module chunks = 0
 **/